import styled from 'styled-components'
import { mobile } from '../../constants/breakpoints'

export const Page = styled.div`
  width: 100%;
  min-height: 100dvh;
  background: linear-gradient(270deg, #d2edfc 39.15%, #f8fcff 62.65%);

  @media (min-width: calc(${mobile} + 1px)) {
    display: none;
  }

  padding: 90px 30px 30px 30px;
`

export const Title = styled.h1`
  margin: 0 0 30px 0;

  color: #4c5197;
  text-align: center;
  font-family: Poppins;
  font-size: 50px;
  font-style: normal;
  font-weight: 600;
  line-height: 60px; /* 120% */

  span {
    color: #c779de;
    font-family: Poppins;
    font-size: 50px;
    font-style: normal;
    font-weight: 600;
    line-height: 60px;
  }
`

export const SubTitle = styled.h2`
  margin: 0;

  color: #4c5197;
  text-align: center;
  font-family: Poppins;
  font-size: 25px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

export const OpenButton = styled.a`
  display: flex;
  width: 100%;
  height: 50px;
  padding: 4px 0px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  border-radius: 10px;
  background: linear-gradient(94deg, #ee9bde -34.17%, #9251e2 117.1%);

  text-decoration: none;
  color: #fff;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px; /* 250% */
  letter-spacing: 1.04px;
  outline: none;
  border: none;

  margin: 30px 0;
`

export const BannerImg = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;

  img {
    width: 100%;
    transform: scaleX(-1);

    max-width: 500px;
  }
`
